import { ExternalLinkIcon } from "@chakra-ui/icons";
import {
  Box,
  HStack,
  Icon,
  IconButton,
  Image,
  Stack,
  Text,
} from "@chakra-ui/react";
import { DragControls, Reorder, motion, useDragControls } from "framer-motion";
import { useCallback } from "react";
import { FiTrash2 } from "react-icons/fi";
import { FaGripVertical } from "react-icons/fa";

const MotionItem = motion(Reorder.Item);

const BundleEvent = ({
  isEditingEvents,
  link,
  image,
  name,
  venueName,
  startAt,
  id,
  isDisabled,
  onDelete,
  onDragEnd,
}) => {
  const dragControls = useDragControls();

  const handleMouseDownReorder = useCallback(
    (e: React.PointerEvent) => {
      if (isDisabled) return;

      dragControls.start(e);
      document.addEventListener(
        "mouseup",
        () => {
          onDragEnd();
        },
        { once: true }
      );
    },
    [onDragEnd, isDisabled, dragControls]
  );

  return (
    <MotionItem
      value={id}
      dragListener={false}
      style={{
        userSelect: "none",
        opacity: isDisabled ? 0.5 : 1,
        borderBottom: "1px solid",
        borderBottomColor: "#EDF2F7", // Chakra's gray.100
        paddingTop: "0.5rem",
        paddingBottom: "0.5rem",
      }}
    >
      <HStack justify="space-between" width="100%">
        <HStack
          paddingLeft={!isEditingEvents ? 8 : 0}
          width="calc(100% - 100px)"
        >
          {isEditingEvents && (
            <IconButton
              backgroundColor="transparent"
              aria-label="Reorder event"
              marginLeft={-4}
              onPointerDown={handleMouseDownReorder}
              icon={<Icon color="gray.400" as={FaGripVertical} />}
            />
          )}
          <Box
            w="100px"
            h="100px"
            overflow="hidden"
            justifyContent="center"
            display="flex"
            flexShrink={0}
          >
            <Image
              objectFit="cover"
              rounded="lg"
              height="100%"
              width="100%"
              src={image}
              fallbackSrc="https://content.kydlabs.com/system/plcaeholderimage.png"
            />
          </Box>
          <Stack spacing={0} width="calc(100% - 100px)">
            <Text
              fontSize="lg"
              fontWeight="medium"
              onClick={() => link && window.open(link)}
              cursor="pointer"
              isTruncated
              overflow="hidden"
              textOverflow="ellipsis"
              whiteSpace="nowrap"
            >
              {name}
              <ExternalLinkIcon cursor="pointer" w={3} h={3} ml={4} />
            </Text>
            <Text
              fontSize="sm"
              isTruncated
              overflow="hidden"
              textOverflow="ellipsis"
              whiteSpace="nowrap"
            >
              {venueName}
            </Text>
            <Text
              fontSize="sm"
              isTruncated
              overflow="hidden"
              textOverflow="ellipsis"
              whiteSpace="nowrap"
            >
              {startAt}
            </Text>
          </Stack>
        </HStack>
        {isEditingEvents && (
          <IconButton
            icon={<FiTrash2 />}
            aria-label="Delete event"
            onClick={() => onDelete(id)}
          />
        )}
      </HStack>
    </MotionItem>
  );
};

export default BundleEvent;
